import * as React from 'react';
import { PrescriptionTable } from './PrescriptionTable.js';

const PrescriptionTableContainer = ({ orientation , prescription , name , size ,  })=>{
    return /*#__PURE__*/ React.createElement(PrescriptionTable, {
        orientation: orientation,
        prescription: prescription,
        "aria-label": name,
        size: size
    });
};

export { PrescriptionTableContainer, PrescriptionTableContainer as default };
//# sourceMappingURL=PrescriptionTableContainer.js.map
